module.exports = __webpack_public_path__ + "img/googleslide-addin-thumbnail.1ab61402.png";